export const attendancePendingEventSelector = (key) => (state) =>
  state?.attendance?.pending?.[key] ?? null;
